// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L99k","type":"styles_type__2-96y","choices":"styles_choices__1vPxC"};